import { Button } from '@cokitchen/cokitchen-components';
import { AddressIcon } from 'cokitchen-icons';
import AddressItem from 'components/address-item';
import LocalModal from 'components/base/local-modal';
import useDashboardContext from 'contexts/dashboard.context';
import { LocationObjectType } from 'models/location.model';
import React, { useEffect, useState } from 'react';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';
type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const DefaultAddressSetting = ({ isOpen, onClose }: Props) => {
  const { savedAddressList, refetchDefaultAddress, defaultAddress } = useDashboardContext();
  const [filteredAddressList, setFilteredAddressList] = useState<LocationObjectType[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<LocationObjectType>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (defaultAddress) {
      setSelectedAddress(defaultAddress);
    }
  }, [defaultAddress]);

  useEffect(() => {
    if (defaultAddress) {
      const filteredAddressList = savedAddressList.filter(
        (address) => address.id !== defaultAddress.id
      );
      setFilteredAddressList(filteredAddressList);
    } else {
      setFilteredAddressList(savedAddressList);
    }
  }, [defaultAddress, savedAddressList]);

  const handleSaveDefaultAddress = async () => {
    setLoading(true);
    try {
      await apiService.post('set_default_address', {
        data: {
          id: selectedAddress?.id
        },
        baseURL: process.env.REACT_APP_CORE_API_URL
      });
      await refetchDefaultAddress();
    } catch (err) {
      handleApiError(err, 'Failed to save default address');
    } finally {
      setLoading(false);
      onClose();
    }
  };
  return (
    <LocalModal isOpen={isOpen} onRequestClose={onClose} title='Select Address'>
      <div className='w-full'>
        <div className='w-full min-h-[5vh] max-h-[30vh] overflow-y-scroll no-scrollbar'>
          {defaultAddress && (
            <div
              className='w-full flex items-center justify-between gap-3 py-[18px] border-b-[0.8px] border-b-[#E7E8E9] cursor-pointer'
              onClick={() => {
                setSelectedAddress(defaultAddress ?? undefined);
              }}>
              <div className='flex gap-3 items-center w-[90%]'>
                <AddressIcon />
                <div className='w-[65%]'>
                  <p className='text-[#5E6164] text-sm line-clamp-1'>{defaultAddress?.address}`</p>
                </div>
              </div>
              <span
                className={`ml-auto w-[14px] h-[14px] rounded-full ${
                  selectedAddress === defaultAddress
                    ? 'border-[3.8px] border-[#E60A2B]'
                    : 'border-[1.3px] border-[#D6D8E0]'
                }`}
              />
            </div>
          )}
          {filteredAddressList.map((address, i) => {
            return (
              <AddressItem
                key={i}
                address={address}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                isSettings={true}
              />
            );
          })}
        </div>
        <div className='w-full flex justify-end gap-4'>
          <Button
            variant='block'
            color='gray'
            className='mt-8 h-[41px] w-[139px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031]'
            onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            className='mt-8 h-[41px] w-[139px]'
            loading={loading}
            disabled={selectedAddress === defaultAddress || loading}
            onClick={handleSaveDefaultAddress}>
            Save
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default DefaultAddressSetting;
